import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=5b3d7bf9&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=5b3d7bf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d7bf9",
  null
  
)

component.options.__file = "checkbox.vue"
export default component.exports